import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';
import PreviewImage from 'UiKit/preview-image';
import useGetRequestApproval from 'Domain/reschedule/useGetRequestApproval';

import TableSkeleton from 'View/reschedule/component/table-skeleton';
import { useRequestApprovalState } from 'View/reschedule/state';

import getTableList from './const';

import styles from './styles.module.css';

const Table = () => {
  const { t } = useTranslation('reschedule');
  const { updateState, state, filterState, updateFilterState } = useRequestApprovalState();

  const { data, isFetching } = useGetRequestApproval({ ...filterState, tableView: state?.selectedTab });

  const handleOpenPreview = (images) => updateState({ isOpenImagePreview: true, selectedImagePreview: images });

  const tableList = getTableList(state?.selectedTab, t, handleOpenPreview);

  const handleClosePreview = () => updateState({ isOpenImagePreview: false, selectedImagePreview: [] });
  const onChangePagination = (page) => updateFilterState({ page });
  const onSort = (sort) => updateFilterState({ sort });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching} fallback={<TableSkeleton />}>
        <TableComponent
          columns={tableList}
          dataSource={data?.reschedules}
          onSort={onSort}
          sortingData={filterState?.sort}
          isScrollable={true}
          maxTableHeight="calc(100vh - 372px)"
          maxTableBodyHeight="calc(100vh - 436px)"
          tableComponentHeight="calc(100vh - 279px)"
          tableName="request-approval"
          isDataExist={data?.isDataExist}
          pagination={{
            currentPage: filterState?.page,
            totalData: data?.totalData,
            onChange: onChangePagination,
            isLoading: isFetching,
          }}
        />
      </Condition>

      <PreviewImage images={state?.selectedImagePreview} isOpen={state?.isOpenImagePreview} onClose={handleClosePreview} initialIndex={0} />
    </Box>
  );
};

export default Table;
